import { Link, usePage } from "@inertiajs/react"
import { Bug, CirclePlay, Plus, Users, UserCircle } from "lucide-react"

import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { dashboardPath, matchesPath, newStaffMatchPath, staffUsersPath, staffPlayersPath } from "@/routes"
import type { NavItem } from "@/types"

import AppLogo from "./app-logo"

export function AppSidebar() {
  const { auth } = usePage().props as { auth: { user?: { role: string } | null } }
  const isStaff = auth?.user?.role === "admin" || auth?.user?.role === "coach"

  const mainNavItems: NavItem[] = [
    {
      title: "Dashboard",
      href: dashboardPath(),
      icon: Bug,
    },
    {
      title: "Matches",
      href: matchesPath(),
      icon: CirclePlay,
    },
    ...(isStaff ? [
      {
        title: "Import Match",
        href: newStaffMatchPath(),
        icon: Plus,
      },
      {
        title: "Manage Users",
        href: staffUsersPath(),
        icon: Users,
      },
      {
        title: "Players",
        href: staffPlayersPath(),
        icon: UserCircle,
      },
    ] as NavItem[] : []),
  ]

  return (
    <Sidebar collapsible="icon" variant="inset">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <Link href={dashboardPath()} prefetch>
                <AppLogo />
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent>
        <NavMain items={mainNavItems} />
      </SidebarContent>

      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  )
}
